
(function ($) {
    "use strict";
    $(function () {

        $('.js-meta-slider').slick({
            vertical: true,
            verticalSwiping: true,
            dots: false,
            arrows: true,
            slidesToShow: 4,
            slidesToScroll: 4,
            prevArrow: $('.js-slide-down'),
            nextArrow: $('.js-slide-up'),
            responsive: [
                {
                    breakpoint: 1600,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                    }
                },
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    }
                },

            ]
        });


    });
})(jQuery);
